import styled from "styled-components";

export const ErrorStyle = styled.section`
  .page_404 {
    padding: 40px 0;
    background: #fff;
    font-family: "Arvo", serif;
  }

  .page_404 img {
    width: 100%;
  }

  .four_zero_four_bg {
    background-image: url("https://media1.tenor.com/images/fc000ba0b39c56c1480f00d9a5793b1c/tenor.gif?itemid=4841810");
    height: 400px;
    background-repeat: no-repeat;
    background-position: center;
  }

  .four_zero_four_bg h1 {
    font-size: 80px;
  }

  .four_zero_four_bg h3 {
    font-size: 80px;
  }

  .link_404 {
    color: #fff !important;
    padding: 10px 20px;
    background: #39ac31;
    margin: 20px 0;
    display: inline-block;
    text-decoration: none;
    border-radius: 0.5rem;
  }
  .contant_box_404 {
    margin-top: -50px;
  }
`;
